import "./App.css";
import AdviceCard from "./components/AdviceCard";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <AdviceCard />
      <Footer />
    </div>
  );
}

export default App;
